// extracted by mini-css-extract-plugin
module.exports = {"circle":"_9V3yg","dash":"_14bU_","component":"_3aaO1","rotate":"_28J3Z","primary":"_3k4px"};